module.exports = __webpack_public_path__ + "static/media/48.b3ec1de5.jpg";